import {
  Container,
  Progress,
  ProgressBar,
  ProgressContainer,
  ProgressNumber,
  Subtitle,
  SubtitleRow,
  Title,
} from "./TrainingProgressComponent.styles";

const TrainingProgressComponent = ({ progress, subtitle, title }) => {
  return (
    <Container>
      <Title>{title}</Title>
      <SubtitleRow>
        <Subtitle>{subtitle}</Subtitle>
        <ProgressNumber>{progress || 0}%</ProgressNumber>
      </SubtitleRow>
      <ProgressContainer>
        <ProgressBar />
        <Progress $width={`${progress || 0}%`} />
      </ProgressContainer>
    </Container>
  );
};

export default TrainingProgressComponent;
